__turbopack_context__.v({
  "className": "ibmplexsans_c51e04fa-module__M0KofW__className",
  "variable": "ibmplexsans_c51e04fa-module__M0KofW__variable",
});
